import Pdf from "@/components/Pdf/Pdf";
import queryString from "query-string";
import { useCallback, useState } from "react";
import { Helmet } from "react-helmet";

export default function FilePreview() {
  const query = queryString.parse(window.location.search);
  const fileUrl = query.fileUrl || "";
  const [numPages, setNumPages] = useState<number>(0);
  const htmlFontSize: string = document.getElementsByTagName("html")[0].style.fontSize;
  const defaultWidth = (750 * +htmlFontSize?.split("px")[0]) / 16;
  const onDocumentLoadSuccess = useCallback(({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  }, []);
  return (
    <div className="file-review-page">
      <Helmet title="文件预览" />
      {fileUrl && (
        <div className="pdf-viewer">
          <Pdf
            pages={numPages}
            url={String(fileUrl)}
            onSuccess={onDocumentLoadSuccess}
            width={defaultWidth}
          />
        </div>
      )}
    </div>
  );
}
